import { ReactNode, useEffect } from 'react';

import EmptyState from '@ergeon/core-components/exports/EmptyState.ts';
import { ExclamationTriangleIcon } from '@ergeon/icons/hero/outline';

import { useSentry } from '@/sentry/context';

export interface ErrorProps {
  title?: string;
  description?: string;
  error?: Error;
  children?: ReactNode;
}

export default function BaseError({ title, description, error, children }: ErrorProps) {
  const Sentry = useSentry();

  useEffect(function captureExceptionOnce() {
    if (error) Sentry.captureException(error);
  }, [error, Sentry]);

  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="flex flex-col items-center gap-4">
        <EmptyState
          actions={children ? <>{children}</> : undefined}
          description={description ?? ''}
          icon={<ExclamationTriangleIcon />}
          title={title ?? ''} />
        {error?.message &&
          <p className="paragraph-3 text-gray-500 dark:text-gray-400">Original error message: {error.message}</p>
        }
      </div>
    </div>
  );
}
